module.exports = __webpack_public_path__ + "img/banner-back.6c3f7ed0.png";